import { handleActions } from 'redux-actions';
import { defaultBrowseSettingsWidgetState } from './defaults';
import { BrowseSettingsWidgetData } from './types';
import { initBrowsingPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  INITIAL_SAVE_REQUEST_META,
  saveableWidgetRequestMetaReducer,
} from '../utils';
import {
  setBrowseSettingsWidgetBrowseLimit,
  setBrowseSettingsWidgetBrowsePagingMode,
  setBrowseSettingsWidgetInvisibleBrowsing,
  setBrowseSettingsWidgetTheatreView,
  saveBrowseSettings,
  saveBrowseSettingsSuccess,
  saveBrowseSettingsFailure,
} from './actions';

const mergeBrowseSettingsWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(defaultBrowseSettingsWidgetState);

export default handleActions<BrowseSettingsWidgetData, any>(
  {
    [initBrowsingPage.toString()]: (
      state,
      action: ReturnType<typeof initBrowsingPage>
    ) => {
      const data: BrowseSettingsWidgetData['initialData'] = {
        theatreView: action.payload.data.theatreView,
        invisibleBrowsing: action.payload.data.invisibleBrowsing,
        browseLimit: action.payload.data.browseLimit,
        browseLimitList: action.payload.data.browseLimitList,
        browsePagingMode: action.payload.data.browsePagingMode,
      };

      return {
        initialData: data,
        currentData: data,
        saveRequest: INITIAL_SAVE_REQUEST_META,
        isDirty: false,
      };
    },
    [setBrowseSettingsWidgetTheatreView.toString()]: (
      state,
      action: ReturnType<typeof setBrowseSettingsWidgetTheatreView>
    ) =>
      mergeBrowseSettingsWidgetDataChange(state, {
        theatreView: action.payload.theatreView,
      }),
    [setBrowseSettingsWidgetInvisibleBrowsing.toString()]: (
      state,
      action: ReturnType<typeof setBrowseSettingsWidgetInvisibleBrowsing>
    ) =>
      mergeBrowseSettingsWidgetDataChange(state, {
        invisibleBrowsing: action.payload.invisibleBrowsing,
      }),
    [setBrowseSettingsWidgetBrowseLimit.toString()]: (
      state,
      action: ReturnType<typeof setBrowseSettingsWidgetBrowseLimit>
    ) =>
      mergeBrowseSettingsWidgetDataChange(state, {
        browseLimit: action.payload.browseLimit,
      }),
    [setBrowseSettingsWidgetBrowsePagingMode.toString()]: (
      state,
      action: ReturnType<typeof setBrowseSettingsWidgetBrowsePagingMode>
    ) =>
      mergeBrowseSettingsWidgetDataChange(state, {
        browsePagingMode: action.payload.browsePagingMode,
      }),
    ...saveableWidgetRequestMetaReducer({
      initialAction: saveBrowseSettings,
      successAction: saveBrowseSettingsSuccess,
      failureAction: saveBrowseSettingsFailure,
    }),
  },
  defaultBrowseSettingsWidgetState
);
